<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import Vue from "vue";
	// #ifdef H5
	var VConsole = require("@/utils/vconsole.min.js");
	//  #endif
	export default {
		mounted() {
			// #ifdef H5
			var vConsole = new VConsole();
			//  #endif
			this.setAppInfo();
		},
		methods: {
			async setAppInfo() {
				// 获取系统栏高度
				let that = this;
				return new Promise((resolve, reject) => {
					// uni.getSystemInfo({
					// 	success: function(e) {
					// 		Vue.prototype.StatusBar = e.statusBarHeight;
					// 		// #ifdef H5
					// 		Vue.prototype.CustomBar = e.statusBarHeight + 45;
					// 		// #endif

					// 		// #ifdef APP-PLUS
					// 		if (e.platform == "android") {
					// 			Vue.prototype.CustomBar = e.statusBarHeight + 50;
					// 		} else {
					// 			Vue.prototype.CustomBar = e.statusBarHeight + 45;
					// 		}
					// 		// #endif

					// 		// #ifdef MP-WEIXIN
					// 		let custom = wx.getMenuButtonBoundingClientRect();
					// 		Vue.prototype.Custom = custom;
					// 		Vue.prototype.CustomBar =
					// 			custom.bottom + custom.top - e.statusBarHeight;
					// 		// #endif
					// 	},
					// });
					let e = uni.getWindowInfo()
					Vue.prototype.StatusBar = e.statusBarHeight;
					// #ifdef H5
					Vue.prototype.CustomBar = e.statusBarHeight + 45;
					// #endif
					
					// #ifdef APP-PLUS
					if (e.platform == "android") {
						Vue.prototype.CustomBar = e.statusBarHeight + 50;
					} else {
						Vue.prototype.CustomBar = e.statusBarHeight + 45;
					}
					// #endif
					
					// #ifdef MP-WEIXIN
					let custom = wx.getMenuButtonBoundingClientRect();
					Vue.prototype.Custom = custom;
					Vue.prototype.CustomBar =
						custom.bottom + custom.top - e.statusBarHeight;
					// #endif
				});
			},
		},
	};
</script>

<style lang="scss">
	/*每个页面公共css */
	@import "animate.css";
	@import "uview-ui/index.scss";
	@import "./assets/iconfont/iconfont.css";
	@import "./assets/css/base.less";
	@import "./assets/css/reset.less";
	@import "./assets/css/style.less";
	@import "./assets/css/coupon.less";

	@font-face {
		//本地只能引入base64位的字体  引入线上资源包
		font-family: "苹方黑体-准-简";
		// src: url("https://vkceyugu.cdn.bspapp.com/VKCEYUGU-ebde41d2-9b74-4616-b75e-1f376d5dc99c/b50d656d-ecc7-457c-b965-023ad77ee763.ttf")
		//   format("truetype");
		font-weight: normal;
		font-style: normal;
	}

	page {
		font-family: "苹方黑体-准-简";
		font-size: 28rpx;
		color: #333333;
		background-color: #f9fafb;
		padding-bottom: 0;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
		box-sizing: border-box;
	}

	.img40 {
		width: 40rpx;
		height: 40rpx;
	}

	.wfiocn {
		width: 28rpx;
		height: 24rpx;
	}

	.img10 {
		width: 20rpx;
		height: 20rpx;
	}

	.img100 {
		width: 100rpx;
		height: 100rpx;
	}

	.img340 {
		width: 340rpx;
		height: 340rpx;
	}

	.wd {
		text-align: center;
		width: 48%;
	}

	.fx1 {
		flex: 1;
	}

	.fx {
		display: flex;
	}

	.df {
		display: flex;
	}

	.dfajc {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dfac {
		display: flex;
		align-items: center;
	}

	.dfacjs {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.dfacja {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.dfacjc {
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.t1 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	.t2 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.placeInp {
		color: #969799;
		font-size: 28rpx;
	}

	.beige {
		background-color: #ffffff;
	}

	.beige1 {
		background: #841022;
	}

	.beige_1 {
		// background-color: #ead3ae1a;
		background: rgba(132, 16, 34, .1);
	}

	.beige2 {
		background-color: #f8f9fa;
	}

	.beige3 {
		background-color: #3e560d;
	}

	.beige4 {
		background-color: #f2f6f9;
	}

	.beige5 {
		background-color: #ff393a;
	}

	.beige6 {
		background-color: #ead3af;
	}

	.beige7 {
		background-color: #d5c186;
	}

	.beige8 {
		background-color: #f6f8f8;
	}

	.beige9 {
		background-color: #eafaf1;
	}

	.beige10 {
		background-color: #bfa76a;
	}

	.bdm {
		border-bottom: 1rpx solid #ebedf0;
	}

	.bd {
		border: 1rpx solid #ff393a;
	}

	.bd2 {
		border: 1rpx solid #dcdee0;
	}

	.bd1 {
		border: 1rpx solid #ead3af;
	}

	.col1 {
		color: #ffffff;
	}

	.col2 {
		color: #333333;
	}

	.col3 {
		// color: #ead3af;
		color: #841022;
	}

	.col4 {
		color: #969799;
	}

	.col5 {
		color: #ff393a;
	}

	.tdlh {
		text-decoration: line-through;
	}

	.col6 {
		color: #c8c9cc;
	}

	.col7 {
		color: #646566;
	}

	.col8 {
		color: #3e560d;
	}

	.col9 {
		color: #ff8201;
	}

	.col10 {
		color: #F9DDAB;
	}

	.delline {
		text-decoration: line-through;
	}

	.include {
		position: absolute;
		left: 0;
		top: 5rpx;
		width: 88rpx;
		height: 32rpx;
		line-height: 32rpx;
		color: #fff;
		text-align: center;
		letter-spacing: 2rpx;
		border-radius: 2rpx;
		font-size: 24rpx;
		background-color: #e51b13;
	}

	.quota {
		position: absolute;
		left: 0;
		top: 0;
		width: 116rpx;
		height: 42rpx;
		line-height: 42rpx;
		color: #fff;
		text-align: center;
		letter-spacing: 2rpx;
		border-radius: 16rpx 0 16rpx 0;
		font-size: 24rpx;
		background-color: #e51b13;
	}

	.fs {
		font-size: 20rpx;
	}

	.fs24 {
		font-size: 24rpx;
	}

	.fs26 {
		font-size: 26rpx;
	}

	.fs32 {
		font-size: 32rpx;
	}

	.fs36 {
		font-size: 36rpx;
	}

	.pad20 {
		padding: 20rpx;
		box-sizing: border-box;
	}

	.pd10 {
		padding: 0 10rpx;
		box-sizing: border-box;
	}

	.pad24 {
		padding: 24rpx;
		box-sizing: border-box;
	}

	.pd24 {
		padding: 0 24rpx;
		box-sizing: border-box;
	}

	.pd30 {
		padding: 0 30rpx;
		box-sizing: border-box;
	}

	.pt24 {
		padding: 24rpx 0;
	}

	.pad30 {
		padding: 30rpx;
		box-sizing: border-box;
	}

	.pad35 {
		padding: 35rpx;
		box-sizing: border-box;
	}

	.bdr16 {
		border-radius: 16rpx;
	}

	.bdt16 {
		border-radius: 16rpx 16rpx 0 0;
	}

	.bdr22 {
		border-radius: 22rpx;
	}

	.bdr50 {
		border-radius: 50rpx;
	}

	.mt30 {
		margin-top: 24rpx;
	}

	.mb10 {
		margin-bottom: 10rpx;
	}

	.mb15 {
		margin-bottom: 15rpx;
	}

	.mb24 {
		margin-bottom: 24rpx;
	}

	.mb30 {
		margin-bottom: 30rpx;
	}

	.fw {
		font-weight: bold;
	}

	.lh50 {
		height: 50rpx;
		line-height: 50rpx;
	}

	.lh72 {
		height: 72rpx;
		line-height: 72rpx;
	}

	.lh88 {
		height: 88rpx;
		line-height: 88rpx;
	}

	.lh80 {
		height: 80rpx;
		line-height: 80rpx;
	}

	.Btn50 {
		width: 176rpx;
		height: 64rpx;
		line-height: 64rpx;
		border-radius: 50rpx;
		text-align: center;
		margin-right: 20rpx;

		&:last-child {
			margin-right: 0;
		}
	}

	.gradient {
		background: #841022;
	}

	.Btn {
		transition: all 0.25s linear;
		position: fixed;
		right: 0;
		left: 0;
		bottom: calc(3% + constant(safe-area-inset-bottom));
		bottom: calc(3% + env(safe-area-inset-bottom));
		text-align: center;
		width: 88%;
		color: #ffffff;
		letter-spacing: 1px;
		height: 80rpx;
		line-height: 80rpx;
		margin: 0 auto;
	}

	.ZoomIn {
		&:active {
			animation: ZoomInandout 0.25s;
		}
	}

	@keyframes ZoomInandout {
		0% {
			transform: scale(1);
		}

		30% {
			transform: scale(0.9);
		}

		60% {
			transform: scale(1);
		}

		90% {
			transform: scale(0.9);
		}

		100% {
			transform: scale(1);
		}
	}

	.userHead {
		position: sticky;
		top: var(--window-top);
		left: 0;
		right: 0;
		z-index: 1;
		width: 100%;
		height: 80rpx;

		.nav_list {
			height: 80rpx;
			line-height: 74rpx;

			.navItem {
				text-align: center;
				width: 160rpx;
			}

			.linAcitv {
				margin: 0 auto;
				height: 6rpx;
				width: 35rpx;
				border-radius: 50rpx;
			}
		}

		.navItem {
			text-align: center;
			width: calc(100% / 2);
		}

		.linAcitv {
			margin: 0 auto;
			height: 6rpx;
			width: 35rpx;
			border-radius: 50rpx;
		}
	}

	.vip {
		display: inline-block;
		text-align: center;
		padding: 0 15rpx;
		box-sizing: border-box;
		letter-spacing: 1rpx;
		height: 36rpx;
		line-height: 36rpx;
		font-size: 22rpx;
		border-radius: 4rpx;
	}
</style>